import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Menu } from '@fiverr-private/orca';
import { getContext } from '@fiverr-private/fiverr_context';
import { user } from '../../../PropTypes';
import SellerDropdown from '../../../components/Seller/SellerDropdown';
import { AccountDashboardLink, TeamDashboardLink } from '../MemberLinks';
import { sendClickEventToBianka } from '../events';

const TeamDashboardMenu = (props, { user }) => {
    const { userId, pageCtxId } = getContext();

    const handleClick = (element_name) => {
        const clickData = {
            event_type: 'clicked_go_to_dashboard_seller_team_account',
            ctx_id: pageCtxId,
            account_id: user.teamAccount.id,
            member_id: userId,
            element_name,
        };
        sendClickEventToBianka(clickData);
    };

    return (
        <SellerDropdown
            triggerLabel={<I18n k="header.dashboard" />}
            menu={
                <Menu className="seller-menu">
                    <Menu.Item>
                        <AccountDashboardLink
                            sellerUsername={user.username}
                            onClick={() => handleClick('seller dashboard')}
                        />
                    </Menu.Item>
                    <Menu.Item>
                        <TeamDashboardLink
                            teamOwnerUsername={user.teamAccount?.slug}
                            onClick={() => handleClick('team dashboard')}
                            isUppercase
                        />
                    </Menu.Item>
                </Menu>
            }
        />
    );
};

TeamDashboardMenu.contextTypes = {
    user,
};

export default TeamDashboardMenu;
